import { locale } from 'core-js';
import moment from 'moment';

export const timestamp = () => {
	return moment(new Date()).format('YYYYMMDDHHmmss');
};

export const formatDateTime = timestamp => {
	return timestamp ? moment(timestamp).format('YYYY-MM-DD HH:mm:ss') : '';
};

export const formatDateTimeLocale = (dateString, locale = 'zh-TW') => {
	const date = new Date(dateString);
	return date.toLocaleString(locale, {
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
		second: '2-digit',
	});
};

// datestring = '2021-01-01 00:00:00'
// toTimestamp(datestring) => 1609459200000
export const toTimestamp = datestring => {
	return moment(datestring, 'YYYY-MM-DD HH:mm:ss').valueOf();
};

// isostring = '2021-01-01T00:00:00.000Z'
export const formatISOstring = isostring => {
	return moment(isostring).format('YYYY-MM-DD HH:mm:ss');
};

// isostring = '2021-01-01T00:00:00.000Z'
export const isoTimestamp = isostring => {
	if (/^\d+$/.test(isostring)) return isostring;
	return moment(isostring).valueOf();
};

// 回傳 isostring = '2021-01-01T00:00:00.000Z'
export const timestampToISO = timestamp => {
	// 將 timestamp 轉換為秒
	// const timestampInSeconds = timestampInMinutes * 60;
	// 將 timestamp 轉換為 ISO 格式
	return timestamp === null
		? null
		: moment(timestamp).toISOString().slice(0, 16);
};

// 瀏覽器本地時間的 datetime-local 格式字串。這個方法簡單且直接地獲取了用戶當前電腦的本地時間。
export const getLocalISOString = () => {
	const date = new Date();
	const year = date.getFullYear();
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const day = String(date.getDate()).padStart(2, '0');
	const hours = String(date.getHours()).padStart(2, '0');
	const minutes = String(date.getMinutes()).padStart(2, '0');

	return `${year}-${month}-${day}T${hours}:${minutes}`;
};

export const dayDiff = to => {
	const d = moment(to).diff(new Date(), 'days');
	var s = '已結束';
	if (d > 0) {
		s = '還有' + new String(d) + '天';
	}
	return s;
};
